var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-layout',{attrs:{"align-center":"","justify-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm10":"","md8":""}},[_c('v-img',{attrs:{"alt":"Flexline logo","flex":"","src":require("../assets/Flexline Toolbar Logo(400 x 100 px).png")}})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }